import { gql } from 'apollo-angular'

export default gql`
  mutation delete_comment_by_pk($id: Int!) {
    delete_comment(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`
